module.exports = __webpack_public_path__ + "static/media/YM60_3.7e3d9966.jpg";